<template lang="html">
<th id="rulerHeader" class="tlHeader" :style="getStyle">
  <span class="tlHeaderText" style="font-size: 12px; margin: auto;">教室<br />＼<br />時刻</span>
</th>
</template>

<script>

export default {
  props: [
    'classroom' // 教室名
  ],
  computed: {
    getStyle () {
      let style = { }
      style.height = this.$store.state.tbHeaderHeight + 'px'
      style.width = this.$store.state.rulerWidth + 'px'
      if (this.$window.scrollX > 0 && this.$window.scrollY > 0) {
        style.position = 'absolute'
        style.top = '0px'
        style.left = this.$window.scrollX + 'px'
        style['border-top'] = 'solid 1px black'
        style.height = this.$store.state.tbHeaderHeight + 1 + 'px'
        // style['z-index'] = 1002
      } else if (this.$window.scrollX > 0) {
        style.position = 'absolute'
        style.left = this.$window.scrollX + 2 + 'px'
        style.top = this.$store.state.headerHeight + 2 + 'px'
        style.height = this.$store.state.tbHeaderHeight + 1 + 'px'
        style['border-left'] = 'solid 2px black'
        // style['z-index'] = 1002
      } else if (this.$window.scrollY > 0) {
        style.position = 'absolute'
        style.left = this.$window.scrollX + 'px'
        style.top = '0px'
        style['border-left'] = 'solid 1px black'
        style['border-top'] = 'solid 1px black'
        style.height = this.$store.state.tbHeaderHeight + 1 + 'px'
        // style['z-index'] = 1002
      } else {
      }
      return style
    }
  }
}
</script>

<style lang="css" scoped>
#rulerHeader {
  box-sizing: border-box; /* ボーダー幅を無視 */
  text-align: center;
  letter-spacing: normal;
  background-color: white;

  border-top-style: none;
  border-left-style: none;

  border-bottom-style: solid;
  border-bottom-width: 2px;
  border-bottom-color: black;

  border-right-style: solid;
  border-right-width: 1px;
  border-right-color: #aaaaaa;

  margin-left: -1px;
}
.tlHeaderText {
  margin: auto;
  white-space: pre;
}
</style>



// WEBPACK FOOTER //
// RulerHeader.vue?8bf11c18